export default __webpack_public_path__ + "static/media/empty-heart.3e5f0cff.png";